import { AuthGuard } from './auth.guard';
import { StaffGuard } from './staff.guard';
import { AuthService } from './auth.service';

export const AUTH_PROVIDERS = [
  AuthService,
  AuthGuard,
  StaffGuard,
];